export enum GroupType {
  Manual = 'Manual',
  Smart = 'Smart',
}
